import { motion } from "framer-motion";
import { Logo } from "@/components/atoms/Logo";

/**
 * Usado enquanto o estado de autenticação está sendo resolvido.
 * Nunca um spinner genérico solto na tela — sempre com a identidade do app.
 */
export function FullScreenLoader() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background">
      <motion.div
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ duration: 1.4, repeat: Infinity, ease: "easeInOut" }}
      >
        <Logo variant="mark" size={120} />
      </motion.div>
      <div className="flex gap-1.5" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="h-1.5 w-1.5 rounded-full bg-primary"
            animate={{ opacity: [0.25, 1, 0.25] }}
            transition={{ duration: 1.1, repeat: Infinity, delay: i * 0.15 }}
          />
        ))}
      </div>
      <span className="sr-only">Carregando</span>
    </div>
  );
}
